import { useAuth } from '@workos-inc/authkit-react'
import { useEffect } from 'react'
import Spinner from './spinner'

export function LoginScreen() {
  const { signIn, isLoading } = useAuth()

  useEffect(() => {
    console.log('[Auth] LoginScreen mounted — Convex reported Unauthenticated', {
      at: new Date().toISOString(),
      url: window.location.href,
    })
  }, [])

  useEffect(() => {
    if (!isLoading) {
      console.log('[Auth] calling signIn() from LoginScreen', { at: new Date().toISOString() })
      void signIn()
    }
  }, [signIn, isLoading])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Spinner className="size-10" />
        <p className="text-sm text-muted-foreground">Preusmerjanje na prijavo...</p>
      </div>
    </div>
  )
}
